import {mergeAttributes, Node} from '@tiptap/core';

const getAnchor = (element) => {
  if (element.nodeName === 'A') return element;
  return element.querySelector('a');
};

function getAttachmentMediaType(name) {
  return name != null ? name.split(".").pop().toLowerCase() : "blank"
}

export default Node.create({
  name: 'reference',
  inline: true,
  group: 'inline',
  atom: false,

  addAttributes() {
    return {
      className: {
        default: null,
        parseHTML: (element) => getAnchor(element).className,
      },
      referenceType: {
        default: null,
        parseHTML: (element) => getAnchor(element).dataset.referenceType,
      },
      originalText: {
        default: null,
        parseHTML: (element) => getAnchor(element).dataset.original,
      },
      href: {
        default: null,
        parseHTML: (element) => getAnchor(element).getAttribute('href'),
      },
      text: {
        default: null,
        parseHTML: (element) => getAnchor(element).textContent,
      },
      dataId: {
        default: null,
        parseHTML: (element) => getAnchor(element).dataset.reference,
      }
    };
  },

  parseHTML() {
    return [
      {
        tag: 'a',
      },
      {
        tag: 'span.label',
      },
    ];
  },

  renderHTML({node}) {
    return [
      'a',
      {
        class: node.attrs.className,
        href: node.attrs.href,
        'data-reference-type': node.attrs.referenceType,
        'data-original': node.attrs.originalText,
        'data-reference': node.attrs.dataId
      },
      node.attrs.text,
    ]
    // if(node.attrs.referenceType === 'file') {
    //   return [
    //     'a',
    //     {
    //       class: node.attrs.className,
    //       href: node.attrs.href,
    //       'data-reference-type': node.attrs.referenceType,
    //       'data-original': node.attrs.originalText,
    //       'data-reference': node.attrs.dataId
    //     },
    //     ['img', {src: require(`../../TecnaFileIcon/fileIcon/${getAttachmentMediaType(node.attrs.text)}.png`), width: "20px"}],
    //     ['span', node.attrs.text],
    //   ]
    // } else {
    //   return [
    //     'a',
    //     {
    //       class: node.attrs.className,
    //       href: node.attrs.href,
    //       'data-reference-type': node.attrs.referenceType,
    //       'data-original': node.attrs.originalText,
    //       'data-reference': node.attrs.dataId
    //     },
    //     node.attrs.text,
    //   ]
    // }
  },
})
